var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_360.svg",
    "data-name": "360.svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.228,
    height: 63,
    viewBox: "0 0 117.228 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_96",
    "data-name": "\\uC0AC\\uAC01\\uD615 96",
    width: 117.228,
    height: 63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_137",
    "data-name": "\\uADF8\\uB8F9 137",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_399",
    "data-name": "\\uD328\\uC2A4 399",
    d: "M195.705,66.461c0,8.769-18.956,16.114-44.526,18.12l6.639-4.485-7.347-4.308c23.133-.926,40.625-5.316,40.625-11.7,0-3.773-5.954-7.1-15.846-10.407-.06-.024-.108-.035-.168-.059-.961-.344-.5-1.5.48-1.223,12.341,3.406,20.144,8.449,20.144,14.061",
    transform: "translate(-78.478 -27.597)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_400",
    "data-name": "\\uD328\\uC2A4 400",
    d: "M58.608,71.114v5.15C32.569,75.824,8.8,71.28,8.8,64.421c0-2.907,4.274-5.731,11.189-8.08a1.721,1.721,0,0,0-1.056-3.275C7.3,56.47,0,61.36,0,66.794,0,77.106,26.23,85.46,58.608,85.46v5.47L74.766,80.595Z",
    transform: "translate(0 -27.93)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_401",
    "data-name": "\\uD328\\uC2A4 401",
    d: "M70.43,46.344l-1.7-.8a6.689,6.689,0,0,1-2.736-2.334,8.349,8.349,0,0,1-1.309-3.681H68.49A3.947,3.947,0,0,0,69.2,41.37a3.309,3.309,0,0,0,1.418,1.077,5.41,5.41,0,0,0,2.041.352,4,4,0,0,0,2.872-.977,3.615,3.615,0,0,0,1.024-2.749v-.8a4.4,4.4,0,0,0-.969-3.048,3.51,3.51,0,0,0-2.744-1.075H70.96V30.646h1.885a3.136,3.136,0,0,0,2.415-.923,3.674,3.674,0,0,0,.86-2.6V26.3a3.137,3.137,0,0,0-.906-2.4,3.614,3.614,0,0,0-2.57-.851,3.953,3.953,0,0,0-1.7.352,3.244,3.244,0,0,0-1.272,1.086,4.916,4.916,0,0,0-.759,1.835H65.123A9.5,9.5,0,0,1,66.5,22.634,6.726,6.726,0,0,1,69.076,20.3a7.721,7.721,0,0,1,3.568-.8,7.425,7.425,0,0,1,5.324,1.79,6.627,6.627,0,0,1,1.885,5.046v.434a5.629,5.629,0,0,1-1.08,3.436,6.1,6.1,0,0,1-3.055,2.135,5.422,5.422,0,0,1,3.376,2.116,6.954,6.954,0,0,1,1.2,4.2v.435a8.028,8.028,0,0,1-.9,3.924,5.894,5.894,0,0,1-2.608,2.479,9.193,9.193,0,0,1-4.126.849Z",
    transform: "translate(-33.736 -10.281)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_402",
    "data-name": "\\uD328\\uC2A4 402",
    d: "M110.651,45.714A6.071,6.071,0,0,1,108.117,43a9.715,9.715,0,0,1-.869-4.295,14.552,14.552,0,0,1,.348-3.093,17.619,17.619,0,0,1,1.006-3.166c.073-.181.153-.358.237-.533s.171-.347.256-.516l5.782-11.321H118.9L112.115,33.19l.018-.651a3.2,3.2,0,0,1,1.336-1.32,4.281,4.281,0,0,1,2.049-.471,6.587,6.587,0,0,1,3.549.923,5.783,5.783,0,0,1,2.251,2.686,10.585,10.585,0,0,1,.768,4.241,9.975,9.975,0,0,1-.869,4.358,6.089,6.089,0,0,1-2.543,2.75,9.067,9.067,0,0,1-8.023.008m6.742-3.7a4.517,4.517,0,0,0,.961-3.093,5.193,5.193,0,0,0-1.007-3.428,3.536,3.536,0,0,0-2.873-1.2,3.045,3.045,0,0,0-2.58,1.212,5.576,5.576,0,0,0-.915,3.418,4.5,4.5,0,0,0,.961,3.1,3.98,3.98,0,0,0,5.452-.008",
    transform: "translate(-55.935 -10.583)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_403",
    "data-name": "\\uD328\\uC2A4 403",
    d: "M150.519,44.312a7.527,7.527,0,0,1-1.931-5.5V26.859a7.5,7.5,0,0,1,1.94-5.507,9.153,9.153,0,0,1,11.316-.009,7.512,7.512,0,0,1,1.931,5.516V38.813a7.5,7.5,0,0,1-1.94,5.508,9.123,9.123,0,0,1-11.317-.009m8.582-2.56a4.182,4.182,0,0,0,.942-2.939V26.859a4.207,4.207,0,0,0-.933-2.939,4.7,4.7,0,0,0-5.854,0,4.21,4.21,0,0,0-.933,2.939V38.813a4.18,4.18,0,0,0,.942,2.939,4.678,4.678,0,0,0,5.837,0",
    transform: "translate(-77.496 -10.219)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_404",
    "data-name": "\\uD328\\uC2A4 404",
    d: "M188.549,9.515a4.791,4.791,0,0,1-4.813-4.758,4.814,4.814,0,0,1,9.627,0,4.791,4.791,0,0,1-4.814,4.758m0-6.55a1.792,1.792,0,1,0,1.812,1.791,1.8,1.8,0,0,0-1.812-1.791",
    transform: "translate(-95.827 0.001)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360Icon);
export default __webpack_public_path__ + "static/media/360_icon.1756939b9f69b27f36374fde5347a368.svg";
export { ForwardRef as ReactComponent };